// extracted by mini-css-extract-plugin
module.exports = {"slide":"slider-module--slide--2blpu","booking":"slider-module--booking--3lbIH","send":"slider-module--send--1KcFR","swiper":"slider-module--swiper--39m00"};